import React, { useContext, useState } from 'react';
import { CartContext } from '../../cartContext';
import { Image } from 'react-bootstrap';
import CustomAlert from '../../customAlert';
import defaultImage from '../../../images/Logo.png';
import { getLocalStorageItem } from '../../../helpers/storage';
//import { axiosAuthFetch } from '../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../constants';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button'
import Loader from '../../loader';
import styles from './checkout.module.css';
import emailjs from 'emailjs-com';
import axios from 'axios';

export default function CheckoutPage() {
  const userInfo = getLocalStorageItem('vp-portal-user');
  const userId = userInfo?.user?.id || null;
  const { cartItems, removeFromCart, clearCart, increaseQuantity, decreaseQuantity } = useContext(CartContext);
  const [isLoading, setIsLoading] = useState(false);
  const [alertData, setAlertData] = useState({
      show: false,
      message: '',
      isError: false,
  });
  const [formData, setFormData] = useState({
      contactPerson: '',
      contactEmail: '',
      comment: '',
  });
  const [showOfferAlert, setShowOfferAlert] = useState(false);

  const handleRemove = (combinedId) => {
      removeFromCart(combinedId);
  };

  const handleClearCart = () => {
      clearCart();
  };

  const handleIncreaseQuantity = (combinedId) => {
      increaseQuantity(combinedId);
  };

  const handleDecreaseQuantity = (combinedId) => {
      decreaseQuantity(combinedId);
  };

  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
  };

  const handleOfferButtonClick = () => {
      setShowOfferAlert(true);
  };

  const handleAlertClose = () => {
      setAlertData({ show: false, message: '', isError: false });
  };

  //eslint-disable-next-line
  const sendOrder = async (orderData, userId) => {
    // if (userId) {
    //   // Bruker er logget inn – send med auth
    //   return await axiosAuthFetch(`${API_BASE_URL}/orders`, { data: orderData }, 'POST');
    // } else {
    //   // Gjestebestilling – bruk vanlig axios uten auth
      return await axios.post(`${API_BASE_URL}/orders`, orderData);
  };

//   const handleFormSubmit = async (e) => {
//       e.preventDefault();
//       setIsLoading(true);

//       const orderItems = cartItems.reduce((acc, item) => {
//         const product = item.data || item;
//         const productId = product.id || product.data.id;
//         const variant = item.selectedVoltage || 'default';
//         const key = `${productId}-${variant}`;
//         if(!acc[key]) {
//             acc[key] = { productName: product.attributes.name, productId, variant, quantity: 0, price:product.attributes?.price || 0 }
//         }
//         acc[key].quantity += item.quantity;
//         return acc;
//       },{});

//       const total_price = Object.values(orderItems).reduce((total, item) => {
//         return total + item.price * item.quantity;
//       }, 0);

//     //   const price = cartItems.reduce((total, item) => {
//     //       const product = item.data || item;
//     //       const productPrice = product.attributes?.price || 0;
//     //       return total + productPrice * item.quantity;
//     //   }, 0);
//     //   const totalPris = parseFloat(price);

//       const orderData = {
//           dateOrdered: new Date().toISOString().split('T')[0],
//           total_price,
//           user: userId,
//           is_guest: userId ? false : true,
//           order_product: Object.values(orderItems).map(item => ({
//             product_to_order:item.productId,
//             variant: item.variant,
//             quantity: item.quantity,
//             name: item.productName,
//             price: item.price
//           })),
//           status: 'pending',
//           contact_person: formData.contactPerson,
//           comment: formData.comment,
//           contact_email: formData.contactEmail
//       };

//       try {
//           //const response = await axiosAuthFetch(`${API_BASE_URL}/orders`, { data: orderData }, 'POST');
//           const response = await sendOrder({ data: orderData }, userId);
//           console.log(response.data);

//           const emailOrders = cartItems.map(item => {
//             const product = item.data || item;
//             const productImage = product.attributes?.image?.data?.attributes?.url || defaultImage;
//             const productName = product.attributes?.name || 'Ukjent navn';
//             const quantity = item.quantity;
//             const productPrice = product.attributes?.price || 0;
//             const supplier = product.attributes?.supplier?.data?.attributes?.name || 'ukjent leverandør';
//             return {
//                 image_url: productImage,
//                 name: productName,
//                 units: quantity,
//                 price: productPrice,
//                 supplier: supplier,
//             };
//         });

//         const templateParams = {
//             email: formData.contactEmail, // Dette vises nederst i malen din
//             orders: emailOrders,
//             cost: {
//                 total: total_price,

//             }
//         };

//         // Send e-posten via EmailJS
//         emailjs.send('service_orodo6s', 'template_pa38jkk', templateParams, 'FgLxzEO_1IGLXfUD-',
//           )
//           .then((result) => {
//               console.log('E-post sendt!', result.text);
//           }, (error) => {
//               console.error('Feil ved sending av e-post:', error);
//           });

//           setAlertData({
//               show: true,
//               message: 'Din forespørsel er sendt!',
//               isError: false,
//           });
//           clearCart();
//           setShowOfferAlert(false);
//       } catch (error) {
//           console.error(error);
//           setAlertData({
//               show: true,
//               message: 'Det oppstod en feil. Vennligst prøv igjen.',
//               isError: true,
//           });
//       }
//       setIsLoading(false);
//   };

const handleFormSubmit = async (e) => {
  e.preventDefault();
  if (isLoading) return;           // hindre dobbel submit
  setIsLoading(true);

  try {
    // 1) Klient-validering
    if (!formData.contactPerson?.trim() || !formData.contactEmail?.trim()) {
      throw new Error('Mangler kontaktperson eller e-post.');
    }
    if (!Array.isArray(cartItems) || cartItems.length === 0) {
      throw new Error('Handlekurven er tom.');
    }

    // 2) Bygg ordredata med “guards”
    const orderItemsMap = cartItems.reduce((acc, item) => {
      const product = item.data || item;
      const productId = product?.id ?? product?.data?.id;
      if (!productId) return acc;     // hopp over defekte items

      const variant = item.selectedVoltage || 'default';
      const key = `${productId}-${variant}`;
      const price = Number(product?.attributes?.price ?? 0) || 0;
      if (!acc[key]) {
        acc[key] = {
          productName: product?.attributes?.name ?? 'Ukjent navn',
          productId,
          variant,
          quantity: 0,
          price
        };
      }
      acc[key].quantity += Number(item.quantity ?? 0);
      return acc;
    }, {});

    const orderProducts = Object.values(orderItemsMap).filter(it => it.quantity > 0);
    if (orderProducts.length === 0) {
      throw new Error('Kunne ikke lage ordren – ingen gyldige produkter.');
    }

    const total_price = orderProducts.reduce((sum, it) => sum + it.price * it.quantity, 0);

    const orderData = {
      dateOrdered: new Date().toISOString().split('T')[0],
      total_price,
      // NB: vurder å la backend sette user/is_guest basert på cookie/token,
      // og ignorere klientens "user" felt for sikkerhet:
      user: userId,
      is_guest: !userId,
      order_product: orderProducts.map(item => ({
        product_to_order: item.productId,
        variant: item.variant,
        quantity: item.quantity,
        name: item.productName,
        price: item.price
      })),
      status: 'pending',
      contact_person: formData.contactPerson.trim(),
      comment: formData.comment?.trim() ?? '',
      contact_email: formData.contactEmail.trim()
    };

    // 3) Send ordre – vis konkret feilmelding hvis server sier nei
    let response;
    try {
      response = await axios.post(`${API_BASE_URL}/orders`, { data: orderData }, { timeout: 12000 });
    } catch (err) {
      const status = err?.response?.status;
      const serverMsg =
        err?.response?.data?.error?.message ||
        err?.response?.data?.message ||
        err?.message ||
        'Ukjent feil';
      console.error('Order API feilet:', status, serverMsg, err?.response?.data);
      throw new Error(status ? `Ordre feilet (${status}): ${serverMsg}` : `Ordre feilet: ${serverMsg}`);
    }

    console.log('Order opprettet:', response?.data);

    // 4) Send e-post – await og egen feilhåndtering
    try {
      const emailOrders = cartItems.map(item => {
        const product = item.data || item;
        const productImage = product?.attributes?.image?.data?.attributes?.url || defaultImage;
        const productName = product?.attributes?.name || 'Ukjent navn';
        const supplier = product?.attributes?.supplier?.data?.attributes?.name || 'ukjent leverandør';
        const quantity = Number(item.quantity ?? 0);
        const productPrice = Number(product?.attributes?.price ?? 0) || 0;
        return { image_url: productImage, name: productName, units: quantity, price: productPrice, supplier };
      });

      const templateParams = {
        email: formData.contactEmail,
        orders: emailOrders,
        cost: { total: total_price }
      };

      await emailjs.send('service_orodo6s', 'template_pa38jkk', templateParams, 'FgLxzEO_1IGLXfUD-');
      console.log('E-post sendt via EmailJS');
    } catch (emailErr) {
      console.error('E-post feilet:', emailErr);
      setAlertData({
        show: true,
        message: 'Forespørselen er mottatt, men e-posten feilet. Vi følger opp manuelt.',
        isError: false
      });
      clearCart();
      setShowOfferAlert(false);
      setIsLoading(false);
      return;
    }

    // 5) Alt OK
    setAlertData({ show: true, message: 'Din forespørsel er sendt!', isError: false });
    clearCart();
    setShowOfferAlert(false);

  } catch (error) {
    console.error('Submit-feil:', error);
    setAlertData({
      show: true,
      message: String(error?.message ?? 'Det oppsto en feil. Vennligst prøv igjen.'),
      isError: true
    });
  } finally {
    setIsLoading(false);
  }
};


  const price = cartItems.reduce((total, item) => {
      const product = item.data || item;
      const productPrice = product.attributes?.price || 0;
      return total + productPrice * item.quantity;
  }, 0);
  const formattedPrice = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK' }).format(price);

  const numericPrice = parseFloat(price);
  const estimertFrakt = numericPrice * 0.10;
  const estimertFraktOnScreen = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK' }).format(estimertFrakt);

  const totalPris = numericPrice;
  const totalPrisOnScreen = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK' }).format(totalPris);

  return (
      <div>
          <h2 className='my-5'>Din handlekurv</h2>
          {cartItems.length === 0 ? (
              <p>Handlekurven er tom.</p>
          ) : (
              <div className={styles.container}>
                  <ul className={styles.listParent}>
                      {cartItems.map((item, index) => {
                          const product = item.data || item;
                          const productId = product.id || product.data.id;
                          const productName = product.attributes?.name || 'Ukjent navn';
                          const productImage = product.attributes?.image?.data?.attributes?.url || defaultImage;
                          const combinedId = item.combinedId || `${productName}-${productId}-${index}`;
                          const supplier = product.attributes?.supplier?.data?.attributes?.name || '';

                          //console.log(`Key for item: ${combinedId}`);

                          return (
                              <li className={styles.listChild} key={combinedId}>
                                    <div className="col-2">
                                        <Image src={productImage} alt={productName} fluid />
                                    </div>
                                    <div className={styles.listSub}>
                                        <div className={styles.listSub2}>
                                            <div className={styles.listName}>{productName}</div>
                                            <div className={styles.supplier}>{supplier}</div>
                                            <div>Antall: {item.quantity}</div>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <Button className="pluss-button ms-3" onClick={() => handleIncreaseQuantity(combinedId)}>+</Button>
                                            <Button className="minus-button ms-2" onClick={() => handleDecreaseQuantity(combinedId)}>-</Button>
                                            <Button className="fjern-button" onClick={() => handleRemove(combinedId)}>Fjern</Button>
                                        </div>
                                    </div>
                              </li>
                          );
                      })}
                  </ul>
                  <div>
                      <div className="mt-5 overstreket">Original pris: {formattedPrice}</div>
                      <div className="overstreket">Estimert frakt: {estimertFraktOnScreen}</div>
                      <div className="">Du har frakt inkludert!</div>
                      <div className="total-pris mt-3">Din pris ink frakt: {totalPrisOnScreen}</div>
                  </div>
                  <div className={styles.buttonDiv}>
                    <Button className="clear-cart-button text-white" onClick={handleClearCart}>Tøm handlekurv</Button>
                    <Button className="be-om-tilbud-button text-white" onClick={handleOfferButtonClick}>Be om tilbud</Button>
                  </div>
              </div>
          )}

          <Modal show={showOfferAlert} onHide={() => setShowOfferAlert(false)}>
              <Modal.Header closeButton>
                  <Modal.Title>Be om tilbud</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  {isLoading && <Loader />}
                  <form onSubmit={handleFormSubmit}>
                      <div className="d-flex flex-column align-items-center">
                          <label>
                              <input
                                  className="input-button"
                                  placeholder="Kontaktperson"
                                  type="text"
                                  name="contactPerson"
                                  value={formData.contactPerson}
                                  onChange={handleChange}
                                  required
                              />
                          </label>
                          <label>
                              <input
                                  className="input-button"
                                  placeholder="E-post"
                                  type="email"
                                  name="contactEmail"
                                  value={formData.contactEmail}
                                  onChange={handleChange}
                                  required
                              />
                          </label>
                          <label>
                              <textarea
                                  className="input-button"
                                  placeholder="Melding"
                                  name="comment"
                                  value={formData.comment}
                                  onChange={handleChange}
                                  required
                              />
                          </label>
                          <Button
                              className="be-om-tilbud-button"
                              type="submit"
                          >Send</Button>
                      </div>
                  </form>
              </Modal.Body>
          </Modal>

          <CustomAlert
              show={alertData.show}
              handleClose={handleAlertClose}
              message={alertData.message}
              isError={alertData.isError}
              buttonLabel="Jeg forstår!"
              buttonClassName="login-button text-white"
          />
      </div>
  );
}